import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';
import { Data } from '../components/selectable-tabs/normal-screen-components/service-call-index';

@Injectable()
export class CommonDataService {
  // toggle continue & View summary variable declarations
  public colorFlag: boolean;
  public addColorFlag: boolean;
  public upholsteryFlag:boolean;
  public rimFlag: boolean;
  public trimFlag: boolean;
  public factoryFlag: boolean;
  public packageFlag: boolean;
  public localFlag: boolean;
  public deselectValue = [];
  public deselectFlag: boolean;
  public progressBarColorFlag = false;
  public progressBarNewOrderColorFlag= false;
  public progressBarNewOrderUpholsteryFlag= false;
  public localDeselectFlag = false;
  public acceptFlag = false;
  public vehicleInfo: any;
  public suggestDataList = [];
  public selectedLocalPackageOptions: Data[] = [];
  public  item = [];
  public jsonValue : any;

  constructor() {
    
   }

  // toggle continue & View summary functions
  public setColorFlag() {
    this.colorFlag = true;
  }

  public setAddColorFlag() {
    this.addColorFlag = true;
  }

   public setUpholsteryFlag() {
    this.upholsteryFlag = true;
  }

  public setRimFlag() {
    this.rimFlag = true;
  }

  public setTrimFlag() {
    this.trimFlag = true;
  }

  public setFactoryFlag() {
    this.factoryFlag = true;
  }

  public setLocalFlag() {
    this.localFlag = true;
  }

  public setPackageFlag() {
    this.packageFlag = true;
  }

  //fetching the class image
  private selectedClass = new Subject<any>();
  getSelectedClass(): Observable<any> {
    return this.selectedClass.asObservable();
  }
  sendSelectedClass(item: any) {
    this.selectedClass.next(item);
  }
  
  //fetching the class name
  private selectedClassName = new Subject<any>();
  getSelectedClassName(): Observable<any> {
    return this.selectedClassName.asObservable();
  }
  sendSelectedClassName(item: any) {
    this.selectedClassName.next(item);
  }

  // alternate options send and get Suggestion
  private validationDataList = new Subject<any>();

  sendSuggestion(item: any) {
    this.validationDataList.next(item);
  }

  getSuggestion(): Observable<any> {
    return this.validationDataList.asObservable();
  }

// Summary validation
  private summaryDataList = new Subject<any>();

   sendSummary(item: any) {
    this.summaryDataList.next(item);
  }

  getSummary(): Observable<any> {
    return this.summaryDataList.asObservable();
  }

  

  
  //navigate from one component to another
  private notify = new Subject<any>();
  notifyObservable$ = this.notify.asObservable();
  public notifyOther(data: any) {
    if (data) {
      this.notify.next(data);
    }
  }

    //Send price to banner area
    private notifyPrice = new Subject<any>();
    notifyPriceObservable$ = this.notifyPrice.asObservable();
    public notifyPriceItem(data: any) {
      if (data) {
        this.notifyPrice.next(data);
      }
    }

  //notify if change in language
  private notifyLanguage = new Subject<any>();
  notifyObservableLanguage$ = this.notifyLanguage.asObservable();
  public notifyLanguageItem(data: any) {
    if (data) {
      this.notifyLanguage.next(data);
    }
  }
  

  //notify to view details in package options for global package
  private notifyPackage = new Subject<any>();
  notifyObservablePackage$ = this.notifyPackage.asObservable();
  public notifyPackageItem(data) {
    if (data) {
      this.notifyPackage.next(data);
    }
  }

  // alternate error message
  private notifyErrMsg = new Subject<any>();
  notifyObservableAltErrMsg$ = this.notifyErrMsg.asObservable();
  public notifyErrorMsgItem(data: any) {
    if (data) {
      this.notifyErrMsg.next(data);
    }
  }

  //testLanguage
  private notifyLanguageChange = new Subject<any>();
  notifyObservableLanguageChangeMsg$ = this.notifyLanguageChange.asObservable();
  public notifyLanguageChangeItems(data: any) {
    if (data) {
      this.notifyErrMsg.next(data);
    }
  }

  //notify if change in package-options and local-package-options
  private notifyAllPackageOptions = new Subject<any>();
  notifyObservableAllPackageOptions$ = this.notifyAllPackageOptions.asObservable();
  public notifyAllPackageOptionsItem(data: any) {
    if (data) {
      this.notifyAllPackageOptions.next(data);
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/services/common-data.service.ts